module.exports = __webpack_public_path__ + "img/3-3.652b87cc.png";